export enum DashboardItemDataGraphTypesModel {
  'DEFAULT' = 0,
  'PIE' = 1,
  'PIE_MONTHLY_AGG' = 2,
  'PIE_WEEKLY_AGG' = 3,
  'HEATMAP' = 4,
  'HEATMAP_DAILY' = 5,
  'SANKEY' = 6,
}
